/* Furmigo theme behaviour — vanilla JS, no dependencies.
   Works against Shopify's AJAX cart (/cart/add.js, /cart/update.js, /cart.js).
   Set window.FM_MOCK = true (preview) to use an in-memory cart instead. */
(function () {
  'use strict';
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));
  const ls = {
    get(k, d) { try { const v = localStorage.getItem(k); return v == null ? d : JSON.parse(v); } catch (e) { return d; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };

  /* ---------- Pet toggle (All / Dogs / Cats) ---------- */
  const html = document.documentElement;
  html.dataset.pet = ls.get('fm.pet', 'all');
  $$('[data-pet-btn]').forEach(b => {
    b.setAttribute('aria-pressed', String(b.dataset.petBtn === html.dataset.pet));
    b.addEventListener('click', () => {
      html.dataset.pet = b.dataset.petBtn; ls.set('fm.pet', html.dataset.pet);
      $$('[data-pet-btn]').forEach(x => x.setAttribute('aria-pressed', String(x === b)));
      document.dispatchEvent(new CustomEvent('fm:pet', { detail: html.dataset.pet }));
    });
  });

  /* Pet toggle also re-points category tiles and rail "See all" links to the pet-filtered view */
  const PET_COL = { dog: 'dogs', cat: 'cats' };
  function applyPetLinks() {
    const pet = html.dataset.pet; const col = PET_COL[pet];
    $$('[data-fm-cat]').forEach(a => {
      const h = a.dataset.fmCat; const base = a.dataset.fmUrl || a.getAttribute('href');
      a.setAttribute('href', col && h ? '/collections/' + col + '/category-' + h : base);
    });
    $$('.fm-section__more[href^="/collections/"]').forEach(a => {
      if (!a.dataset.fmBase) a.dataset.fmBase = a.getAttribute('href');
      const bm = a.dataset.fmBase.match(/^\/collections\/([a-z0-9-]+)\/?$/);
      if (!bm || ['dogs','cats','small-pets','offers','under-499','under-999','all','vendors','frontpage'].includes(bm[1])) return;
      a.setAttribute('href', col ? '/collections/' + col + '/category-' + bm[1] : a.dataset.fmBase);
    });
  }
  applyPetLinks(); document.addEventListener('fm:pet', applyPetLinks);

  /* ---------- Utility strip rotator ---------- */
  $$('[data-fm-rotate]').forEach(strip => {
    const items = $$('.fm-utility__item', strip); if (items.length < 2) return;
    let i = 0; setInterval(() => { items[i].classList.remove('is-active'); i = (i + 1) % items.length; items[i].classList.add('is-active'); }, 4000);
  });

  /* ---------- Search placeholder cycling ---------- */
  $$('[data-fm-placeholders]').forEach(inp => {
    const words = inp.dataset.fmPlaceholders.split('|'); let i = 0;
    setInterval(() => { i = (i + 1) % words.length; inp.placeholder = 'Search for ‘' + words[i] + '’'; }, 2500);
  });

  /* ---------- Copy coupon ---------- */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-fm-copy]'); if (!b) return;
    const code = b.dataset.fmCopy;
    (navigator.clipboard ? navigator.clipboard.writeText(code) : Promise.resolve()).then(() => {
      b.classList.add('is-done'); b.textContent = 'Copied'; toast('Code ' + code + ' copied');
      setTimeout(() => { b.classList.remove('is-done'); b.textContent = 'Copy'; }, 2000);
    });
  });

  /* ---------- Toast ---------- */
  let toastEl;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'fm-toast'; document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-show');
    clearTimeout(toastEl._t); toastEl._t = setTimeout(() => toastEl.classList.remove('is-show'), 1800);
  }

  /* ---------- Sheet ---------- */
  function openSheet(title, bodyHTML, mode) {
    let s = $('#fm-sheet');
    if (!s) {
      s = document.createElement('div'); s.id = 'fm-sheet'; s.className = 'fm-sheet';
      s.innerHTML = '<div class="fm-sheet__bg" data-close></div><div class="fm-sheet__panel" role="dialog" aria-modal="true"><div class="fm-sheet__grab"></div><div class="fm-sheet__head"><div class="fm-sheet__title"></div><button type="button" class="fm-sheet__close" data-close aria-label="Close">&times;</button></div><div class="fm-sheet__body"></div></div>';
      document.body.appendChild(s);
      s.addEventListener('click', e => { if (e.target.closest('[data-close]')) closeSheet(); });
      document.addEventListener('keydown', e => { if (e.key === 'Escape') closeSheet(); });
    }
    s.className = 'fm-sheet' + (mode ? ' fm-sheet--' + mode : '');
    $('.fm-sheet__title', s).textContent = title; $('.fm-sheet__body', s).innerHTML = bodyHTML; s.classList.add('is-open');
    document.documentElement.classList.add('fm-lock');
    return s;
  }
  function closeSheet() { const s = $('#fm-sheet'); if (s) s.classList.remove('is-open'); document.documentElement.classList.remove('fm-lock'); }
  document.addEventListener('click', e => {
    const t = e.target.closest('[data-fm-sheet]'); if (!t) return; e.preventDefault();
    const tpl = $(t.dataset.fmSheet); if (tpl) openSheet(t.dataset.fmSheetTitle || '', tpl.innerHTML, t.dataset.fmSheetMode || '');
  });

  /* ---------- Search overlay (suggestions + Shopify predictive search) ---------- */
  const searchTpl = $('#fm-search-sheet');
  if (searchTpl) {
    let timer = null;
    const esc = h => String(h).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const render = (box, q, data) => {
      if (!data) { box.innerHTML = ''; return; }
      const prods = (data.resources.results.products || []).slice(0, 6);
      const cols = (data.resources.results.collections || []).slice(0, 4);
      let h = '';
      if (cols.length) h += '<div class="fm-srch__label">Categories</div><div class="fm-srch__chips">' + cols.map(c => '<a class="fm-chip" href="' + c.url + '">' + esc(c.title) + '</a>').join('') + '</div>';
      if (prods.length) h += '<div class="fm-srch__label">Products</div>' + prods.map(p => '<a class="fm-srch__row" href="' + p.url + '"><img src="' + (p.featured_image && p.featured_image.url ? p.featured_image.url.replace(/(\.[a-z]+)(\?|$)/, '_120x$1$2') : '') + '" alt="" loading="lazy"><span><b>' + esc(p.title) + '</b><small>' + esc(p.vendor || '') + ' · ' + money(Math.round(parseFloat(p.price) * 100)) + '</small></span></a>').join('');
      if (!h) h = '<div class="fm-srch__label">No matches for “' + esc(q) + '” — try a brand or category</div>';
      h += '<a class="fm-srch__all" href="/search?q=' + encodeURIComponent(q) + '&options[prefix]=last">See all results for “' + esc(q) + '” ›</a>';
      box.innerHTML = h;
    };
    const open = (prefill) => {
      const s = openSheet('', searchTpl.innerHTML, 'full');
      const inp = $('input[type=search]', s); const box = $('[data-fm-srch-results]', s); const quick = $('[data-fm-srch-quick]', s);
      inp.value = prefill || ''; setTimeout(() => inp.focus(), 50);
      inp.addEventListener('input', () => {
        const q = inp.value.trim(); clearTimeout(timer);
        if (q.length < 2) { box.innerHTML = ''; quick.hidden = false; return; }
        quick.hidden = true;
        timer = setTimeout(async () => {
          try {
            const r = await fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=hide');
            render(box, q, await r.json());
          } catch (err) { box.innerHTML = ''; }
        }, 220);
      });
    };
    document.addEventListener('focusin', e => {
      const inp = e.target.closest('.fm-header .fm-search input[type=search]'); if (!inp || inp.dataset.fmNoOverlay) return;
      inp.blur(); open(inp.value);
    });
  }

  /* ---------- Cart ---------- */
  const mock = { items: {} };
  const cart = {
    async state() {
      if (window.FM_MOCK) return { item_count: Object.values(mock.items).reduce((a, b) => a + b, 0), items: Object.entries(mock.items).map(([id, q]) => ({ variant_id: +id, quantity: q })) };
      return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json());
    },
    async add(id, qty) {
      if (window.FM_MOCK) { mock.items[id] = (mock.items[id] || 0) + qty; return this.state(); }
      const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id, quantity: qty }] }) });
      if (!r.ok) throw new Error((await r.json()).description || 'Could not add');
      return this.state();
    },
    async set(id, qty) {
      if (window.FM_MOCK) { if (qty <= 0) delete mock.items[id]; else mock.items[id] = qty; return this.state(); }
      const r = await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: { [id]: qty } }) });
      return r.json();
    }
  };
  function paintCount(state) {
    const n = state.item_count || 0;
    $$('[data-fm-cart-count]').forEach(el => { el.dataset.count = n; el.textContent = n; el.classList.remove('fm-bump'); void el.offsetWidth; el.classList.add('fm-bump'); });
    const byId = {}; (state.items || []).forEach(i => { byId[i.variant_id] = (byId[i.variant_id] || 0) + i.quantity; });
    $$('.fm-tile[data-variant]').forEach(tile => {
      const q = byId[tile.dataset.variant] || 0;
      tile.classList.toggle('is-in-cart', q > 0);
      const out = $('output', tile); if (out) out.value = q;
    });
    document.dispatchEvent(new CustomEvent('fm:cart', { detail: state }));
  }
  cart.state().then(paintCount).catch(() => {});

  document.addEventListener('click', async e => {
    const add = e.target.closest('[data-fm-add]');
    const step = e.target.closest('[data-fm-step]');
    if (!add && !step) return;
    e.preventDefault(); e.stopPropagation();
    const tile = e.target.closest('.fm-tile, [data-variant]');
    try {
      if (add) {
        const variants = add.dataset.fmVariants ? JSON.parse(add.dataset.fmVariants) : null;
        if (variants && variants.length > 1) return variantSheet(add.dataset.fmTitle || 'Choose size', variants);
        const id = +(add.dataset.fmAdd || (tile && tile.dataset.variant));
        paintCount(await cart.add(id, 1)); toast('Added to bag');
      } else {
        const id = +tile.dataset.variant; const cur = +($('output', tile).value || 0);
        const next = Math.max(0, cur + (step.dataset.fmStep === '+' ? 1 : -1));
        paintCount(await cart.set(id, next)); if (next === 0) toast('Removed from bag');
      }
    } catch (err) { toast(err.message || 'Could not add'); }
  });

  function variantSheet(title, variants) {
    const body = '<div class="fm-chips" style="flex-wrap:wrap;margin:0;padding:0 0 12px">' +
      variants.map((v, i) => `<button class="fm-chip fm-chip--pill${i === 0 ? ' is-active' : ''}" data-v="${v.id}" data-price="${v.price}" ${v.available === false ? 'disabled' : ''}>${v.title}</button>`).join('') +
      '</div><div style="display:flex;align-items:center;justify-content:space-between"><div><span class="fm-tile__price"><span class="p" data-sheet-price>' + money(variants[0].price) + '</span></span><div style="font-size:12px;color:var(--fm-ink-2)">Incl. of all taxes</div></div><button class="fm-btn" data-sheet-add data-v="' + variants[0].id + '">Add to bag</button></div>';
    const s = openSheet(title, body);
    s.onclick = async e => {
      const chip = e.target.closest('[data-v].fm-chip'); const addB = e.target.closest('[data-sheet-add]');
      if (chip) { $$('.fm-chip', s).forEach(c => c.classList.remove('is-active')); chip.classList.add('is-active'); $('[data-sheet-price]', s).textContent = money(+chip.dataset.price); $('[data-sheet-add]', s).dataset.v = chip.dataset.v; }
      if (addB) { paintCount(await cart.add(+addB.dataset.v, 1)); closeSheet(); toast('Added to bag'); }
      if (e.target.closest('[data-close]')) closeSheet();
    };
  }
  function money(paise) { return '₹' + (paise / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 }); }

  /* ---------- Wishlist (localStorage) ---------- */
  const wl = new Set(ls.get('fm.wl', []));
  $$('[data-fm-wish]').forEach(b => b.setAttribute('aria-pressed', String(wl.has(b.dataset.fmWish))));
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-fm-wish]'); if (!b) return; e.preventDefault(); e.stopPropagation();
    const id = b.dataset.fmWish; wl.has(id) ? wl.delete(id) : wl.add(id); ls.set('fm.wl', [...wl]);
    b.setAttribute('aria-pressed', String(wl.has(id))); toast(wl.has(id) ? 'Saved to wishlist' : 'Removed from wishlist');
  });

  /* ---------- Tabs (Categories page) ---------- */
  $$('[data-fm-tabs]').forEach(tabs => {
    tabs.addEventListener('click', e => {
      const b = e.target.closest('button[data-tab]'); if (!b) return;
      $$('button[data-tab]', tabs).forEach(x => x.setAttribute('aria-selected', String(x === b)));
      const root = tabs.closest('[data-fm-tabroot]') || document;
      $$('[data-tabpanel]', root).forEach(p => p.hidden = p.dataset.tabpanel !== b.dataset.tab);
    });
  });

  /* ---------- Pincode ---------- */
  document.addEventListener('submit', e => {
    const f = e.target.closest('[data-fm-pincode]'); if (!f) return; e.preventDefault();
    const pin = $('input', f).value.trim(); if (!/^\d{6}$/.test(pin)) return toast('Enter a 6-digit pincode');
    ls.set('fm.pin', pin); $$('[data-fm-pin]').forEach(el => el.textContent = pin);
    const d = new Date(); d.setDate(d.getDate() + (pin.startsWith('67') ? 1 : 3));
    const out = $('[data-fm-pin-result]', f.parentElement) || $('[data-fm-pin-result]');
    if (out) out.textContent = 'Delivery by ' + d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' }) + ' · COD available';
    closeSheet();
  });
  const savedPin = ls.get('fm.pin', null); if (savedPin) $$('[data-fm-pin]').forEach(el => el.textContent = savedPin);

  /* ---------- Hero dots ---------- */
  $$('[data-fm-hero]').forEach(rail => {
    const dots = $$('.fm-dots span', rail.parentElement); if (!dots.length) return;
    rail.addEventListener('scroll', () => { const i = Math.round(rail.scrollLeft / (rail.firstElementChild.offsetWidth + 10)); dots.forEach((d, j) => d.classList.toggle('is-active', j === i)); }, { passive: true });
  });

  /* ---------- Product page: option pills, variant cards, sticky add ---------- */
  $$('[data-fm-product]').forEach(pdp => {
    const cards = $$('.fm-pcard', pdp); const pills = $$('[data-fm-opt1]', pdp);
    const hid = $('[data-fm-form-variant]', pdp); const btn = $('[data-fm-bar-btn]', pdp);
    function pickCard(c) {
      cards.forEach(x => x.classList.toggle('is-active', x === c));
      hid.value = c.dataset.fmVariant;
      const price = +c.dataset.price, mrp = +c.dataset.mrp;
      $('[data-fm-bar-price]', pdp).textContent = money(price);
      $('[data-fm-bar-mrp]', pdp).textContent = mrp > price ? money(mrp) : '';
      $('[data-fm-bar-off]', pdp).textContent = mrp > price ? '(' + Math.round((mrp - price) * 100 / mrp) + '% OFF)' : '';
      const ok = c.dataset.available === 'true'; btn.disabled = !ok; btn.textContent = ok ? 'Add to Cart' : 'Sold out';
      if (history.replaceState) { const u = new URL(location.href); u.searchParams.set('variant', c.dataset.fmVariant); history.replaceState(null, '', u); }
    }
    function filterCards(opt1) {
      let first = null;
      cards.forEach(c => { const show = !opt1 || c.dataset.opt1 === opt1; c.hidden = !show; if (show && !first && !c.disabled) first = c; });
      if (first) pickCard(first);
    }
    pills.forEach(p => p.addEventListener('click', () => { pills.forEach(x => x.classList.toggle('is-active', x === p)); filterCards(p.dataset.fmOpt1); }));
    cards.forEach(c => c.addEventListener('click', () => pickCard(c)));
    if (pills.length) { const active = pills.find(p => p.classList.contains('is-active')); if (active) filterCards(active.dataset.fmOpt1); }
    const form = $('[data-fm-add-form]', pdp);
    form.addEventListener('submit', async e => {
      e.preventDefault();
      try {
        btn.disabled = true; const old = btn.textContent; btn.textContent = 'Adding…';
        paintCount(await cart.add(+hid.value, +($('[name=quantity]', form).value || 1)));
        btn.textContent = 'Go to Bag →'; btn.disabled = false; toast('Added to bag');
        btn.onclick = ev => { ev.preventDefault(); location.href = '/cart'; };
      } catch (err) { toast(err.message || 'Could not add'); btn.disabled = false; btn.textContent = 'Add to Cart'; }
    });
    const more = $('[data-fm-more-offers]', pdp);
    if (more) more.addEventListener('click', () => { $$('[data-more-offer]', pdp).forEach(o => o.hidden = false); more.hidden = true; });
  });

  window.FM = { toast, openSheet, closeSheet, cart };
})();
